import { Card } from "@circleco/compass/components/Card";
import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

interface AvatarListRowProps {
  "aria-expanded"?: boolean;
  "aria-label"?: string;
  label: string;
  onClick: () => void;
  prefix: ReactNode;
}

export const AvatarListRow = ({
  "aria-expanded": ariaExpanded,
  "aria-label": ariaLabel,
  label,
  onClick,
  prefix,
}: AvatarListRowProps) => (
  <Card.Root
    className="min-w-0"
    aria-expanded={ariaExpanded}
    aria-label={ariaLabel}
    onClick={onClick}
  >
    <Card.Body className="p-3">
      <div className="flex items-center gap-3 text-left">
        {prefix}
        <Typography
          variant="label-sm"
          component="span"
          className="min-w-0 flex-1"
          truncate
        >
          {label}
        </Typography>
      </div>
    </Card.Body>
  </Card.Root>
);
